import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <div 
      className="relative bg-basalt-carbon text-ozone-white min-h-[600px] flex items-center" 
      data-testid="hero-section"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/30037320/pexels-photo-30037320.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-basalt-carbon/95 via-basalt-carbon/80 to-basalt-carbon/60"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          <p className="text-solar-kinetic font-semibold uppercase tracking-widest mb-4" data-testid="hero-tagline">
            SOCIAL ENTERPRISE · ADVISORY · DELIVERY
          </p>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" data-testid="hero-headline">
            Consulting for good.
          </h1>
          <p className="text-xl md:text-2xl text-ozone-white/90 mb-4">
            Creating thriving futures, with people and planet at the heart.
          </p>
          <p className="text-lg text-ozone-white/80 mb-8">
            We help organisations build delivery capability & sustainable systems.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/collaborate"
              data-testid="hero-cta-primary"
              className="bg-solar-kinetic text-basalt-carbon px-8 py-4 rounded-full font-semibold hover:bg-solar-kinetic/90 transition-all flex items-center justify-center space-x-2 text-lg"
            >
              <span>Let's Sustainify</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;